import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import appVersion from '../version';

function Footer() {
  const { isDark, toggleTheme } = useTheme();

  return (
    <footer style={{
      textAlign: 'center',
      padding: '10px 20px',
      marginTop: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '15px',
      flexWrap: 'wrap'
    }}>
      <span style={{
        color: 'var(--text-muted)',
        fontSize: '0.75rem',
        opacity: 0.7
      }}>
        version: {appVersion}
      </span>
      <button
        onClick={toggleTheme}
        style={{
          background: 'transparent',
          border: '1px solid var(--border-color)',
          borderRadius: '20px',
          padding: '4px 12px',
          cursor: 'pointer',
          fontSize: '0.75rem',
          color: 'var(--text-muted)',
          opacity: 0.7,
          transition: 'all 0.3s ease'
        }}
        onMouseOver={(e) => {
          e.target.style.opacity = '1';
          e.target.style.borderColor = 'var(--border-hover)';
        }}
        onMouseOut={(e) => {
          e.target.style.opacity = '0.7';
          e.target.style.borderColor = 'var(--border-color)';
        }}
        aria-label="Toggle dark mode"
      >
        {isDark ? '☀️' : '🌙'}
      </button>
    </footer>
  );
}

export default Footer;

